export const DECIMALS = 1_000_000_000_000